import { createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemIconPropsType } from '~/types/ListItemIcon'

export default function ListItemIcon(props: ListItemIconPropsType) {
  const iconClasses = createMemo(() => twMerge('flex items-center justify-center flex-shrink-0', 'w-10 h-10 mr-3', 'text-foreground-muted', props.class))

  return (
    <div class={iconClasses()} classList={props.classList}>
      <div class="w-6 h-6 flex items-center justify-center">{props.children}</div>
    </div>
  )
}
